import {
  WebhookEventType,
  viewExample,
} from '@baserow/modules/database/webhookEventTypes'

/**
 * "Filas que entran a una vista" en el formulario de webhooks del core.
 *
 * Mismo nombre de tipo que el de enterprise a propósito: lo reemplaza, así el
 * formulario no enseña la opción dos veces (una con candado). Sin candado:
 * isDeactivated() se queda en el false de la clase base. El trabajo de verdad
 * está en el backend (extras_mg/webhooks.py).
 *
 * El selector de vista lo pinta el formulario del core cuando
 * getHasRelatedView() es true; solo ofrece vistas que se pueden filtrar.
 */
export class FilasQueEntranAVistaWebhookEventType extends WebhookEventType {
  static getType() {
    return 'view.rows_entered'
  }

  getName() {
    return 'Filas que entran a una vista'
  }

  getExamplePayload(database, table, rowExample) {
    const payload = super.getExamplePayload(database, table, rowExample)
    payload.view = viewExample
    payload.fields = Object.keys(rowExample)
    payload.rows = [rowExample]
    payload.total_count = 1
    return payload
  }

  getHasRelatedView() {
    return true
  }

  getRelatedViewPlaceholder() {
    return 'Elige la vista'
  }

  getRelatedViewHelpText() {
    return (
      'Avisa cuando una fila empieza a cumplir los filtros de la vista: al ' +
      'crearla o al editarla. Las que ya estaban no cuentan. Manda todas las ' +
      'columnas de la tabla, no solo las que se ven en la vista.'
    )
  }
}
